import React from "react";

// --- CSS --- //
import "../../styles/climbers.css";

// --- ASSETS --- //
import mockup_1 from "../../assets/mockup-1.png";
import mockup_2 from "../../assets/mockup-2.png";
import mockup_3 from "../../assets/mockup-3.png";

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


const Climbers = () => {

    return (
        <>
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <h1>Stop Waiting. Start Sending. Now.</h1>
                    <p>The platform for climbers to track certifications, manage progress, and start sending faster than ever. Simplify your journey in seconds and focus on what matters most—climbing.</p>
                    <a href="/sign-up">
                        <button className="cta-button">Sign Up Now</button>
                    </a>
                </div>
                <div className="hero-image">
                    <img src={mockup_3} alt="App Mockup" />
                </div>
                <div className="hero-scroll-down">
                    <KeyboardArrowDownIcon style={{ fontSize: "30pt" }} />
                </div>
            </section>

            {/* Features Section */}
            <section className="features">
                <h2>What's Inside</h2>
                <div className="features-grid">
                    <div className="feature-item">
                        <img src={mockup_1} alt="Feature 1" />
                        <h3>View Certifications Instantly</h3>
                        <p>See your certifications instantly as they’re added to your account—no waiting required. Plus, gain immediate access to climbing gyms nationwide in just seconds.</p>
                    </div>
                    <div className="feature-item" id="feature-middle-item">
                        <img src={mockup_2} alt="Feature 2" />
                        <h3>Nationwide Network of Gyms</h3>
                        <p>Gain instant access to our nationwide network of participating gyms. Your certifications are valid anywhere, anytime you see the VERT CERT logo.</p>
                    </div>
                    <div className="feature-item">
                        <img src={mockup_3} alt="Feature 3" />
                        <h3>Expired? Never Again.</h3>
                        <p>Forget about setting another calendar reminder. Our mobile and web apps will automatically track everything for you.</p>
                    </div>
                </div>
            </section>

            {/* How It Works Section */}
            <section className="how-it-works">
            <object className="background-graphic" aria-label="Background graphic representing VERT CERT experience"></object>
                <h2>The VERT CERT Experience: Your Path to Certification</h2>
                <div className="how-it-works-content">
                    <div className="how-it-works-steps">
                        <div className="step">
                            <h3 className="step-number">1.</h3>
                            <div className="step-content" id="step-content-first-content" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                <div style={{ marginRight: "20px" }}>
                                    <h3>Create Your Profile</h3>
                                    <p>Sign up and create your VERT CERT profile to get started on your climbing journey.</p>
                                </div>
                                <a href="/sign-up"><button className="cta-button" id="step-content-first-content-button">Sign Up Now</button></a>
                            </div>
                        </div>
                        <div className="step">
                            <h3 className="step-number">2.</h3>
                            <div className="step-content">
                                <h3>TEST.</h3>
                                <p>Take and pass a climbing certification test at one of our nationwide partnering gyms.</p>
                            </div>
                        </div>
                        <div className="step">
                            <h3 className="step-number">3.</h3>
                            <div className="step-content">
                                <h3>SCAN.</h3>
                                <p>Let a gym or VERT CERT employee scan your unique VERT CERT ID to add your certifications to your account in seconds.</p>
                            </div>
                        </div>
                        <div className="step">
                            <h3 className="step-number">4.</h3>
                            <div className="step-content">
                                <h3>CLIMB.</h3>
                                <p>Finally, view your certifcations in real time and start climbing with your certifications at any particpating gym nationwide.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call-to-Action Section */}
            <section className="cta">
                <h2>Start Your Climbing Journey Today</h2>
                <p>Be one of the first to experience VERT CERT—a new way to climb and get certified, all in one seamless platform.</p>
                <a href="/sign-up">
                    <button className="cta-button" id="cta-sign-up-button">Sign Up Now</button>
                </a>
            </section>
        </>
    );
};

export default Climbers;